import Tool, { simpleToolButton } from './Tool';
import undoIconSvg from '../assets/icons/undoIcon.svg';
import { svgToIcon } from '../utils/svg';
import Shortcut from '../utils/Shortcut';

class ToolUndo extends Tool {
  static toolName = 'Undo';
  static shortcut = new Shortcut('Cmd+Z');

  static action({ controller }) {
    // If we're currently drafting a comment, it will be the active object.
    // Discarding it will fire the deselected event, which will cancel the
    // new comment and remove it's undo entry.
    if (controller.state.draftingComment) {
      controller.canvas.discardActiveObject();
    }
    controller.undoManager.undo();
  }

  static enabled({ controller }) {
    return controller.hasUndo;
  }

  static buttonComponent() {
    return simpleToolButton(ToolUndo, svgToIcon(undoIconSvg));
  }
}

export default ToolUndo;
